import { useEffect, useMemo, useState } from "react";
import {
	createElementFromHTML,
	transferSVGProperties,
} from "../../../src/_helpers/_dom";
import { Buffer } from "buffer";

const Icon = ({
	name,
	color = "purple-semi-dark",
	filled = true,
	style = {},
	fillOutline = false,
	...props
}) => {
	const [icon, setIcon] = useState(null);

	const Img = require(`../../../src/_assets/icons/${name}.svg`);
	const isBase64 = useMemo(() => typeof Img.default === "string", [Img]);

	useEffect(() => {
		const string = Img.default.replace(/data:image\/[^;]+;base64,/, "");
		setIcon(createElementFromHTML(Buffer.from(string, "base64").toString()));
	}, [isBase64, Img]);

	if (!icon) {
		if (isBase64) {
			return null;
		}
		return (
			<span
				ref={(el) => {
					if (el) {
						setIcon(el.firstChild);
					}
				}}
			>
        <Img/>
      </span>
		);
	}

	return (
		<svg
			ref={(el) => {
				if (el) {
					transferSVGProperties(
						el,
						icon,
						style,
						props,
						color,
						filled,
						fillOutline,
						`icon icon-${name}`
					);
				}
			}}
		/>
	);
};

export default Icon;
